import { addClass, onEscPress, removeClass, setCustomTagHTML } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { modalOptions } from './modal.model';
import { ModalTemplate } from './modal.template';

export class Modal {
	constructor(props) {
		this.wid = props.wrapperId;
		this.cid = props.contentId;

		this.initData(props);
		this.initWrapper();
		this.initComponents();
		this.initEvents();
	}

	initData(props) {
		this.data = { ...modalOptions, closeable: props?.closeable ?? true };

		this.setter(props);
	}

	initWrapper() {
		const { wrapperCss, wrapperId } = this.data || {};

		const wrapper = document.createElement('div');
		wrapper.id = wrapperId;
		wrapper.className = 'engt-modal';
		wrapper.style = wrapperCss || '';
		wrapper.setAttribute('tabindex', -1);
		wrapper.addEventListener('click', this.close);
		wrapper.innerHTML = ModalTemplate(this.data);

		this.html = wrapper;
	}

	initComponents() {
		const { content } = this.data || {};

		setCustomTagHTML(this.html.querySelector('modal-content'), content);
	}

	initEvents() {
		if (this.data.closeable) {
			this.html.querySelector('.engt-modal-close').addEventListener('click', (e) => {
				this.close(e, true);
			});
			this.html.querySelector('.engt-modal-close').addEventListener('keydown', (e) => {
				ENGT_CHAT.get('onEnterPress')(this.close.bind(this, e, true));
			});
		}
	}

	open = () => {
		document.addEventListener('keydown', this.listenForEscape.bind({ wid: this.wid, cid: this.cid }));
		ENGT_CHAT.get('hideMinimizedCallout')?.();
		addClass(document.getElementById(this.wid), 'engt-modal-open');
		addClass(document.getElementById(this.cid), 'engt-modal-animate');
	};

	close = (e, forceClose) => {
		if ((e && e.target.id === this.wid) || forceClose) {
			document.removeEventListener('keydown', this.listenForEscape);
			removeClass(document.getElementById(`${this.wid}`), 'engt-modal-open');
			removeClass(document.getElementById(`${this.cid}`), 'engt-modal-animate');
		}
	};

	listenForEscape = onEscPress((e) => {
		this.close(e, true);
	});

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
